import { IColumn, Icon, IconButton, Link } from "@fluentui/react";

interface UploadListItem {
  id: number;
  name: string;
  type: string;
  date: string;
  attachmentType: string;
  link: () => Promise<string>;
}

interface UploadListColumn {
  id: number;
  name: string;
  type: string;
  date: string;
  attachmentType: string;
  link: () => Promise<string>;
}

const FileExtensionIconType: Record<string, string> = {
  PDF: "PDF",
  JPEG: "FileImage",
  JPG: "FileImage",
  PNG: "FileImage",
  TIFF: "FileImage"
};

const handleOpenLink = (getLinkUrl: () => Promise<string>): void => {
  getLinkUrl()
    .then(url => {
      window.open(url, "_blank");
    })
    .catch(error => {
      console.error("Erro ao abrir link:", error);
    });
};

export const uploadsColumns = (
  handleDelete: (id: number) => Promise<void>
): Array<IColumn> => [
  {
    key: "name",
    name: "Nome",
    fieldName: "name",
    data: "string",
    minWidth: 100,
    maxWidth: 500,
    className: "ms-fontSize-16",
    onRender: (item: UploadListItem) => (
      <Link key={item.name} onClick={() => handleOpenLink(item.link)}>
        {item.name}
      </Link>
    )
  },
  {
    key: "attachmentType",
    name: "Tipo de anexo",
    fieldName: "attachmentType",
    data: "string",
    minWidth: 100,
    maxWidth: 300,
    className: "ms-fontSize-16"
  },
  {
    key: "type",
    name: "Tipo",
    fieldName: "type",
    data: "string",
    minWidth: 40,
    maxWidth: 200,
    className: "ms-fontSize-16"
  },
  {
    key: "date",
    name: "Data",
    fieldName: "date",
    minWidth: 85,
    data: "string",
    className: "ms-fontSize-16"
  },
  {
    key: "icon",
    iconName: "page",
    isIconOnly: true,
    name: "iconName",
    fieldName: "iconName",
    minWidth: 30,
    onRender: (item: UploadListItem) => (
      <Link key={`${item.name}-icon`} onClick={() => handleOpenLink(item.link)}>
        <Icon
          iconName={FileExtensionIconType[item.type] ?? "Document"}
          style={{ color: "#395ca3", fontSize: 20 }}
        />
      </Link>
    )
  },
  {
    key: "delete",
    iconName: "Delete",
    isIconOnly: true,
    name: "delete",
    fieldName: "delete",
    minWidth: 30,
    onRender: (item: UploadListColumn) => (
      <IconButton
        ariaLabel="Excluir documento"
        title="Excluir"
        iconProps={{ iconName: "Delete" }}
        onClick={() => void handleDelete(item.id)}
      />
    )
  }
];
